import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import request from 'utils/request_ajax';
import { useParams } from 'react-router-dom';
import { CheckCircle } from 'react-feather';
import { routes as ROUTES } from 'constants/config';
import { Drag } from 'components/ui/Icon/Streamline';
import { Button, TextEditor } from 'ui';
import DateFormat from 'constants/date_format';
import * as actions from '../../../actions/journeyBuilder';
import { updateBanner, displayBanner } from '../../../actions/journeyBuilder';

const TaskBuilder = ({
  step,
  idx,
  listeners,
  attributes,
  handleCancelClick,
}) => {
  const [loading, setLoading] = useState(false);

  const [taskTitle, setTaskTitle] = useState(step.title);
  const [taskDetails, setTaskDetails] = useState(step.description);

  const dispatch = useDispatch();
  const { journeyId } = useParams();

  const handleSaveTask = () => {
    setLoading(true);
    if (!step.contentId) {
      request
        .postJSON(ROUTES.JOURNEY.TASK.CREATE(journeyId), {
          title: taskTitle,
          detail: taskDetails,
        })
        .then(responseData => {
          const dispatchContent = {
            index: idx,
            step: {
              contentId: responseData.id,
              contentType: step.contentType,
              description: responseData.details,
              id: step.stepId,
              stepId: step.stepId,
              title: responseData.title,
              editing: false,
              targetStepId: step.targetStepId,
            },
          };

          if (dispatchContent.step.targetStepId === null) {
            delete dispatchContent.step.targetStepId;
          }

          request
            .postJSON(ROUTES.JOURNEY.STEPS.CREATE(journeyId), {
              content_type: dispatchContent.step.contentType,
              content_id: dispatchContent.step.contentId,
              target_step_id: dispatchContent.step.targetStepId,
            })
            .then(data => {
              dispatchContent.step.stepId = data.stepId;
              dispatchContent.step.id = data.stepId;
              dispatch(actions.updateStep(dispatchContent));
              dispatch(
                actions.updateAutosavedAt({
                  autosavedAt: moment().format(DateFormat.LONG_AT_TIME),
                }),
              );
            })
            .fail(err => {
              console.error(err);
              dispatch(
                updateBanner({
                  message: t('journeys.builder.reorder_error'),
                  status: 'error',
                }),
              );
              dispatch(
                displayBanner({
                  bannerDismissible: false,
                }),
              );
            });
        })
        .fail(err => {
          console.error(err);
          dispatch(
            updateBanner({
              message: t('journeys.builder.reorder_error'),
              status: 'error',
            }),
          );
          dispatch(
            displayBanner({
              bannerDismissible: false,
            }),
          );
        });
    } else {
      request
        .patchJSON(ROUTES.JOURNEY.TASK.RESOURCE(journeyId, step.contentId), {
          title: taskTitle,
          detail: taskDetails,
          task_id: step.contentId,
        })
        .then(responseData => {
          const dispatchContent = {
            index: idx,
            step: {
              contentId: responseData.id,
              contentType: step.contentType,
              description: responseData.details,
              id: step.id,
              stepId: step.stepId,
              title: responseData.title,
              editing: false,
              targetStepId: step.targetStepId,
            },
          };

          if (dispatchContent.step.targetStepId === null) {
            delete dispatchContent.step.targetStepId;
          }

          dispatch(actions.updateStep(dispatchContent));
          dispatch(
            actions.updateAutosavedAt({
              autosavedAt: moment().format(DateFormat.LONG_AT_TIME),
            }),
          );
        })
        .fail(err => {
          console.error(err);
          dispatch(
            updateBanner({
              message: t('journeys.builder.reorder_error'),
              status: 'error',
            }),
          );
          dispatch(
            displayBanner({
              bannerDismissible: false,
            }),
          );
        });
    }
  };

  return (
    <div className="JourneyContent JourneyContentPicker">
      <div className="JourneyContent-header">
        <div className="JourneyContent-title">
          <div {...listeners} {...attributes}>
            <Drag className="JourneyContent-icon--drag" size={16} />
          </div>
          <CheckCircle className="JourneyContent-icon" size={20} />
          {t('journeys.builder.create_task')}
        </div>
        <button
          type="button"
          className="u-linkBtn u-linkBtn--dark td-u"
          children="Cancel"
          onClick={handleCancelClick}
        />
        <Button
          className="JourneyContentPicker-taskButton"
          customColor
          type="submit"
          loading={loading}
          onClick={handleSaveTask}
          disabled={taskTitle.length === 0 || loading}
        >
          {t('common.done')}
        </Button>
      </div>
      <div className="JourneyContentPicker-body">
        <label htmlFor="title" className="JourneyEditDetailsModal-inputTitle">
          {t('journeys.task.name')} *
        </label>
        <input
          className="AssignModal-searchInput"
          placeholder={t('common.enter_title')}
          maxLength="255"
          value={taskTitle}
          onChange={e => setTaskTitle(e.target.value)}
        />
        <label htmlFor="details" className="JourneyEditDetailsModal-inputTitle">
          {t('journeys.task.details')}
        </label>
        <TextEditor
          className="JourneyContentPicker-taskEditor"
          defaultValue={taskDetails}
          onChange={setTaskDetails}
        />
      </div>
    </div>
  );
};

export default TaskBuilder;
